import Component from "../../../../js/assets/component.js"
import ImageLoader from "../../../../js/assets/image_loader.js"


class SlideShowItem extends Component {
  constructor(el){
    super(el)
  }

  data(){
    return {
      "loading": false,
      "loaded": false,
      "renderType": "bg", //bg or img
      "image_path": null
    }
  }

  changed(){
    return {
      "loaded": ()=>{
        this.renderImage()
      }
    }
  }

  registerImage(imagePath){
    this.$data.image_path = imagePath
    this.imageLoader.register(this.$data.image_path)
  }

  async load(){
    this.$data.loading = true
    //このタイミングでrenderImageしないと画像描画に遅延が生じる
    this.renderImage()
    await this.imageLoader.load()
  }

  async waitLoaded(){
    console.log("wait loading...")
    return new Promise((resolve, reject)=> {
      if(this.$data.loaded === true){
        resolve()
      }else{
        this.addEventListener("loaded", ()=>{
          this.removeEventListener("loaded")
          resolve()
        })
      }
    })
  }

  activate(){
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
  }

  async renderImage(){
    switch(this.$data.renderType){
      case "bg":
        if(this.$bgImageContainer.length !== 0){
          this.$bgImageContainer.css({
            "background-image": `url(${this.$data.image_path})`
          })
        }else{
          this.$el.css({
            "background-image": `url(${this.$data.image_path})`
          })
        }
        break
      case "img":
        if(this.$img.length !== 0){
          this.$img.attr("src", this.$data.image_path)
        }else{
          this.$el.append(this.imageLoader.$data.image)
        }
        break
    }
  }

  mounted(){
    //imageLoader
    this.imageLoader = new ImageLoader()
    this.imageLoader.addEventListener("loaded", ()=>{
      this.$data.loaded = true
    })

    //img
    this.$img = this.$el.find("img")

    //bgImageContainer
    this.$bgImageContainer = this.$el.find("[data-role='bg-image']")
  }
}

export default SlideShowItem
